import { SbBlokData } from '@cinch-nx/data-storyblok'
import { AiSearchInput } from '@cinch-nx/feature-ai-search'
import { globalStoryblokComponents } from '@cinch-nx/storyblok'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { useResponsiveEnvironment } from '@retail-common/util-hooks'
import React, { useMemo } from 'react'
import styles from './ai-search-section.module.css'

export interface AISearchSectionProps {
  heading: string
  searchBoxPlaceholders: SbBlokData[]
  buttons: SbBlokData[]
}

export const AISearchSection: React.FC<AISearchSectionProps> = ({
  heading,
  searchBoxPlaceholders,
  buttons,
}) => {
  const { isMobile } = useResponsiveEnvironment()

  const placeholders = useMemo(
    () =>
      searchBoxPlaceholders
        .map((placeholder) => {
          const text = (placeholder as SbBlokData & { text?: unknown }).text
          return typeof text === 'string' ? text.trim() : ''
        })
        .filter(Boolean),
    [searchBoxPlaceholders],
  )

  return (
    <section className={styles.container}>
      <h2 className={styles.heading}>{heading}</h2>
      <div className={styles.aiSearchWrapper}>
        <AiSearchInput
          placeholders={placeholders}
          showSubmitButton={!isMobile}
        />
      </div>
      <div className={styles.buttonsSection}>
        {buttons.map((button, index) => (
          <StoryblokRenderer
            key={index}
            block={button}
            components={globalStoryblokComponents}
          />
        ))}
      </div>
    </section>
  )
}
